import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';

/**
 * Services 
 */
import { GetCountryStateCityService } from "../../../services/contacts/getCountryStateCity/get-country-state-city.service"
import { GetTitleService } from "../../../services/contacts/getTitle/get-title.service"
import { GetAllLanguageService } from "../../../services/contacts/getAllLanguage/get-all-language.service";
import { GetAllEducationService } from "../../../services/contacts/getAllEducation/get-all-education.service"
import { PinCodeToGetDetailsService } from "../../../services/contacts/pinCodeToGetDetails/pin-code-to-get-details.service";
import {AppComponent} from "../../../app.component";

declare var $: any;
@Component({
  selector: 'app-add-client-contact',
  templateUrl: './add-client-contact.component.html',
  styleUrls: ['./add-client-contact.component.less']
})
export class AddClientContactComponent implements AfterViewInit, OnInit {

  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    // locale: frLocale,
    // minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  public allCSC: any
  public tempState: any
  public allState: any
  public allCity: any
  public allTitle: any
  public allLanguage: any
  public allEduction: any
  public allPinDistrict: any
  public allDistrict: any
  public allPin: any
  public marital = {
    married: false
  }

  public ifSelectedCountryIndia: Boolean
  public mobileNoValidation: Number = 20

  /**
   * no value in selection box
   */
  public noCountryAvailable: Boolean = true
  public noStateAvailable: Boolean = true
  public noCityAvailable: Boolean = true


  /**
   * Validation variables
   */
  public invalidPin: Boolean = false
  public ifForeign: Boolean = true

  /** 
   * Loader variables
   */
  public skeleton: Boolean = true
  public pinCodeLoader: Boolean = false

  /**
   * Pin Code to Populate Auto Data
   */
  public pintoPopulate = {
    city: "", state: "", district: "", address3: ""
  }


  constructor(
    private GetCountryStateCityService: GetCountryStateCityService,
    private GetTitleService: GetTitleService,
    private GetAllLanguageService: GetAllLanguageService,
    private GetAllEducationService: GetAllEducationService,
    private PinCodeToGetDetailsService: PinCodeToGetDetailsService,
    private AppComponent:AppComponent
  ) { }

  async ngOnInit() {
    this.AppComponent.hideAllHeaderSideNavFooter()
    this.allCSC = await this.getAllCSC()
    this.allCSC.push({ name: "None Of This" })
    await this.getTitle()
    await this.getLanguage()
    await this.getEduction()
    // this.allPinDistrict = pinAndDistrict
    var root = this;
    setTimeout(function () {
      root.skeleton = false
    }, 95)
    setTimeout(function () {
      $(`.title`).selectpicker('refresh');
      $(`.language`).selectpicker('refresh');
      $(`.eduction`).selectpicker('refresh');
      $(`.country`).selectpicker('refresh');
      $(`.state`).selectpicker('refresh');
      $("[data-id='State']").prop('disabled', true);
      $(`.city`).selectpicker('refresh');
      $("[data-id='City']").prop('disabled', true);
    }, 100)
  }

  ngAfterViewInit() {
    // console.timeEnd
  }

  async addNewClientContact(ele) {
    console.log(ele)
  }

  async getTitle() {
    let result = await this.GetTitleService.getAllTitle()
    this.allTitle = result.data
  }

  async getLanguage() {
    let result = await this.GetAllLanguageService.getAllLanguage()
    this.allLanguage = result.data
  }

  async getEduction() {
    let result = await this.GetAllEducationService.getAllEducation()
    this.allEduction = result.data
  }

  async getAllCSC() {
    return await this.GetCountryStateCityService.getAll()
  }

  async getSelectedCountry(val) {
    if (val == "None Of This") {
      this.noCountryAvailable = false
      this.noStateAvailable = false
      this.noCityAvailable = false
      this.ifForeign = true
    } else {
      this.noStateAvailable = true
      this.noCityAvailable = true
      if (val == 'India') {
        this.mobileNoValidation = 10
        this.ifForeign = false
      }
      let state = this.allCSC.filter(country => country.name == val)
      this.tempState = state
      this.allState = Object.keys(state[0].states)
      this.allState.push("None Of This")
      setTimeout(function () {
        $(`.state`).selectpicker('refresh');
        $("[data-id='State']").prop('disabled', false);
      }, 100)
    }
  }

  async getSelectedState(val) {
    if (val == "None Of This") {
      this.noStateAvailable = false
      this.noCityAvailable = false
    } else {
      this.noCityAvailable = true
      this.allCity = this.tempState[0].states[val]
      this.allCity.push("None Of This")
      setTimeout(function () {
        $(`.city`).selectpicker('refresh');
        $("[data-id='City']").prop('disabled', false);
      }, 100)
    }
  }

  async pinCodeToGetDetails(value) {
    if (!this.ifForeign) {
      let checkValue = /\d{6}/
      this.invalidPin = false
      if (checkValue.test(value)) {
        this.pinCodeLoader = true
        let result = await this.PinCodeToGetDetailsService.getPinDetails(value)

        if (result.status == 404) {
          this.pinCodeLoader = false
          this.invalidPin = true
        } else {
          this.pinCodeLoader = false
          let selectedPin = result.data 
          this.pintoPopulate.state = selectedPin[0].STATE_NAME
          this.pintoPopulate.district = selectedPin[0].DISTRICT_NAME
//           $("#address3").val(function() {
//     return this.value + ','POST_OFFICE;
// });
          // if (selectedPin.length != 1) {
            this.allState = []
            this.allCity = []
            selectedPin.forEach(element => {
              this.allState.push(element.STATE_NAME)
              this.allCity.push(element.DISTRICT_NAME)
            });
            this.allState.push("None Of This")
            this.allCity.push("None Of This")
            setTimeout(function () {
              $(`.state`).selectpicker('refresh');
              $(`.city`).selectpicker('refresh');
              $("[data-id='City']").prop('disabled', false);
            }, 100)
          }
        // }
      }
    }

  }


  async getSelectedCity(val) {
    if (val == "None Of This") {
      this.noCityAvailable = false
    }
    // this.allPin = this.allPinDistrict.filter(pin => pin.City.match(val))
    // setTimeout(function () {
    //   $(`.pinCode`).selectpicker('refresh');
    //   $("[data-id='PinCode']").prop('disabled', false);
    // }, 100)
  }

  // async getSelectedPinCode(val){
  //   this.allDistrict = this.allPin.filter(pin => pin.Pincode == val)
  //   console.log(this.allDistrict)
  //   setTimeout(function () {
  //     $(`.district`).selectpicker('refresh');
  //     $("[data-id='District']").prop('disabled', false);
  //   }, 100)
  // }

  async onMaritalStatus(ele, val) {
    if (val == 2) {
      this.marital.married = true
    } else {
      this.marital.married = false
    }

  }
  formEmailValidation(elementValue) {
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailPattern.test(elementValue)) {
      $("#email").removeClass("is-invalid")
    } else {
      if ($("#email").hasClass("is-invalid")) {
        $("#email").removeClass("is-invalid")
      } else {
        $("#email").addClass("is-invalid")
      }
    }
  }

  backToSelect(val) {
    switch (val) {
      case 1:
        this.skeleton = true
        this.noCountryAvailable = true
        var root = this
        setTimeout(function () {
          root.skeleton = false
        }, 95)
        setTimeout(function () {
          $(`.country`).selectpicker('refresh');
        }, 100)
        break;
      case 2:
        this.noStateAvailable = true
        setTimeout(function () {
          $(`.state`).selectpicker('refresh');
        }, 100)
        break;
      case 3:
        this.noCityAvailable = true
        setTimeout(function () {
          $(`.city`).selectpicker('refresh');
        }, 100)
        break;
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  // byId(item1, item2) {
  //   console.log(item1, item2)
  //   return item1.id === 'Tamil Nadu';
  // }
  testForm(){
    let path = window.location.href.split("#")
    window.open(path[0]+"#/TestClientContact", '_blank');
  }
}
